import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Badge from 'react-bootstrap/Badge';
import Stack from 'react-bootstrap/Stack';
import Chip from "@mui/material/Chip";

import myImg from "../../assets/IMG_5816 2.jpg";
import { AiOutlineStock } from "react-icons/ai";
import { FaCreditCard } from "react-icons/fa";
import { SiDatadotai } from "react-icons/si";
import { LuAtom } from "react-icons/lu";
import { LuScale3D } from "react-icons/lu";

function Home2() {
    return (
      <Container fluid className="home-about-section" id="about">
        <Container>
{/* ======================================= */}
          <Row>
            <Col md={8} className="home-about-description">
              <h1 style={{ fontSize: "2.6em" }}>
                About <span className="purple"> Me </span> ...
              </h1>
              <p className="home-about-body">
                Currently studying
                <i> <b className="purple"> Msc Risk Management and Data Analytics </b> </i>
                in CUHK.
                <br />
                <br />
                Field of interests include but not limited to
                <i> <b className="purple"> Machine Learning</b>,
                  <b className="purple"> Web Dev</b>,
                  <b className="purple"> Quant</b>,
                  <b className="purple"> Fintech</b>,
                  <b className="purple"> Data Engineering</b>
                </i>....
                <br />
                <br />
                <i> <b className="purple">CFA Level 1</b></i> completeds &emsp;
                <i> <b className="purple">FRM</b></i> (in progress..)
              </p>
            </Col>
            <Col md={4} className="myAvtar">
                <img src={myImg} className="img-fluid" alt="avatar" />
            </Col>
          </Row>
{/* ========================================== */}
          <Row style={{ justifyContent: "center" }}>
            <h1 className="project-heading" style={{ textAlign: "left" }}>
                Professional <strong className="purple">Skillset </strong>
                </h1>
            <h2 className="project-subheading"> <strong className="purple">Finance </strong> </h2>
            <Col md={4} className="skill-icons"> 
              <FaCreditCard />
              <h4>Credit Risk</h4>
              <p>
                Familiar with regular credit risk frameworks, include Basel III, IFRS9, CVA/DVA, model review and etc.
              </p>
              <div className="flex-chips">
                <Chip className='chip' label="Basel III" />
                <Chip className='chip' label="IFRS9" />
                <Chip className='chip' label="CVA" />
                <Chip className='chip' label="Retail Credit Risk" />
                <Chip className='chip' label="Merton Model" />
                <Chip className='chip' label="Credit Default Swap" />
              </div>
            </Col>
            <Col md={4} className="skill-icons">
              <AiOutlineStock />
              <h4>Market Risk</h4>
              <p>
                Experience in developing or validating risk models (e.g., derivatives pricing models, SIMM, VaR, FRTB).
              </p>
              <div className="flex-chips">
                <Chip className='chip' label="VaR & ES" />
                <Chip className='chip' label="Term Structure Models" />
                <Chip className='chip' label="Time Series Analysis" />
                <Chip className='chip' label="Hedging" />
                <Chip className='chip' label="FRTB" />
                <Chip className='chip' label="Interest Rate Risk" />
              </div>
            </Col>

            <h2 className="project-subheading"> <strong className="purple">IT </strong> </h2>
            <Col md={3} className="skill-icons">
              <SiDatadotai />
              <h4>Data Science</h4>
              <p>
                Experience in Data Analysis, Web Scraping, Big Data Integration, Data Engineering, and Business Intelligence...
              </p>
              <div className="flex-chips">
                <Chip className='chip' label="EDA" />
                <Chip className='chip' label="Feature Engineering" />
                <Chip className='chip' label="Selenium" />
                <Chip className='chip' label="Tableau/PowerBI" />
                <Chip className='chip' label="ETL process" />
                <Chip className='chip' label="SQL & NoSQL" />
                <Chip className='chip' label="Hadoop" />
              </div>
            </Col>
            <Col md={3} className="skill-icons">
              <LuScale3D />
              <h4>Machine Learning</h4>
              <p>
                Experience in modern ML techniques to drive business values on diff. projects.
              </p>
              <div className="flex-chips">
                <Chip className='chip' label="NLP" />
                <Chip className='chip' label="LLM" />
                <Chip className='chip' label="AWS" />
                <Chip className='chip' label="Named Entity Recognition" />
                <Chip className='chip' label="Retrieval Augmented Generation" />
                <Chip className='chip' label="Image recognition & Detection" />
              </div>
            </Col>
            <Col md={3} className="skill-icons">
              <LuAtom />
              <h4>Web Devlopment</h4>
              <p>
                Comfortable with both front-end and back-end web development on simple tasks.
              </p>
              <div className="flex-chips">
                <Chip className='chip' label="ReactJS" />
                <Chip className='chip' label="Copy & Paste" />
                <Chip className='chip' label="Git" />
                <Chip className='chip' label="PostgreSQL" />
                <Chip className='chip' label="GitHub Copilot" />
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    );
  }
  export default Home2;